export default __webpack_public_path__ + "static/media/4_2.5bd77116.jpg";